import { useState } from 'react';

export interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

export const COOKIE_CONSENT_KEY = 'after5pm_cookie_consent';
export const COOKIE_PREFERENCES_KEY = 'after5pm_cookie_preferences';

export const defaultPreferences: CookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export function getCookiePreferences(): CookiePreferences {
  try {
    const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    if (stored) {
      return { ...defaultPreferences, ...JSON.parse(stored) };
    }
  } catch {
    // Ignore parse errors
  }
  return defaultPreferences;
}

export function hasConsented(): boolean {
  return localStorage.getItem(COOKIE_CONSENT_KEY) === 'true';
}

export function useCookiePreferences() {
  const [preferences, setPreferencesState] =
    useState<CookiePreferences>(getCookiePreferences);

  const updatePreferences = (newPrefs: Partial<CookiePreferences>) => {
    const updated = { ...preferences, ...newPrefs, necessary: true };
    localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(updated));
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setPreferencesState(updated);
    window.dispatchEvent(
      new CustomEvent('cookieConsentUpdated', { detail: updated })
    );
  };

  const resetConsent = () => {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
    localStorage.removeItem(COOKIE_PREFERENCES_KEY);
    window.location.reload();
  };

  return { preferences, updatePreferences, resetConsent };
}
